<script>
import { defineComponent } from 'vue'
import RedpodiumApiTokensModal from '@/components/api-keys/integration-examples/redpodium-api-tokens-modal.vue'
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwButton from '@/components/generic/tw-button.vue'

export default defineComponent({
  name: 'ApiKeyListGroupItem',
  components: { TwButton, TwListGroupItem, RedpodiumApiTokensModal },
  props: {
    apiKey: {
      type: Object,
      required: true
    }
  },
})
</script>

<template>
  <tw-list-group-item class="bg-gray-100 p-10 border-b-2">
    <div class="flex justify-between items-center">
      Key: <span class="font-bold">{{ apiKey.raw_token? apiKey.raw_token:'Not Visible Anymore' }}</span> <span class="font-bold">Visible: {{ $filters.timeLeft(apiKey.visible_until) }}</span>
      Url: <span class="font-bold">{{ apiKey.api_end_point_url }}</span>
      Expiration: <span class="font-bold">{{ apiKey.expires_at ? new Date(apiKey.expires_at).toLocaleDateString() : 'Never' }}</span>
    </div>
    <div class="mt-4">
      <tw-button size="sm" variant="info" @click="$refs.redPodiumModal.open()">
        RedPodium Integration
      </tw-button>
    </div>
    <redpodium-api-tokens-modal ref="redPodiumModal" :api-token="apiKey" />
  </tw-list-group-item>
</template>

<style scoped>

</style>
